import { __generator } from "tslib";
import { delay, put } from '@redux-saga/core/effects';
import { createAction } from 'redux-actions';
import { markAsFetching } from './base/actions';
export var createCallbackActionCreator = function (actionType) {
    return createAction(actionType, function (streamId) { return ({ streamId: streamId }); });
};
export function throttleFetchingTask(streamId, throttleMs) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, delay(throttleMs)];
            case 1:
                _a.sent();
                return [4 /*yield*/, put(markAsFetching(streamId))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=helpers.js.map